import { ReactElement } from 'react';

import { Dropdown, usePush } from '@dreryk/react-components';

import { getHealthcareProviderDataPath } from '../routes';
import { healthcarePracticeTranslationKeys } from '../translations';

export const MyPracticeDropdownItem = (): ReactElement => {
   const push = usePush();

   return (
      <Dropdown.Item
         testId={'myPractice'}
         onClick={(hide) => {
            push(getHealthcareProviderDataPath('HEALTHCARE_PRACTICE'));
            hide();
         }}
      >
         {healthcarePracticeTranslationKeys.myPractice}
      </Dropdown.Item>
   );
};
